export default "__VITE_ASSET__Pwm_HimB__"